import {NgModule} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {GridModule} from "@progress/kendo-angular-grid";
import {RouterModule} from "@angular/router";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ConfigurationModule} from "@fedeltapointofsale/data-client";
import {OkButtonComponent} from "./buttons/ok-button/ok-button.component";
import {CancelButtonComponent} from "./buttons/cancel-button/cancel-button.component";
import {SecondaryButtonComponent} from "./buttons/secondary-button/secondary-button.component";
import {DateInputsModule} from "@progress/kendo-angular-dateinputs";
import {FileUploadComponent} from "./file/file-upload.component";
import {FileSelectComponent} from "./file-select/file-select.component";
import {UiModule} from "@fedeltapointofsale/ui";
import {DraggableComponent, DraggableHandleComponent} from "./dnd/draggable.component";
import {DroppableComponent} from "./dnd/droppable.component";
import {SortableComponent, SortableContainer, SortableHandleComponent} from "./dnd/sortable.component";

/**
 * The Shared Module is a convenience module which saves declaring reusable components into other modules.
 * The Shared Module may be imported into all other Modules as required to gain access to shared reusable components.
 *
 * The components declared in the Shared Module should be generic in nature and truly reusable.
 *
 * See https://angular.io/guide/ngmodule#shared-modules
 */
@NgModule({
    imports: [
        CommonModule,
        UiModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        DateInputsModule,
        RouterModule,
        BrowserAnimationsModule,
        TranslateModule,
        ConfigurationModule
    ],
    declarations: [
        CancelButtonComponent,
        OkButtonComponent,
        SecondaryButtonComponent,
        FileUploadComponent,
        FileSelectComponent,
        DraggableComponent,
        DraggableHandleComponent,
        DroppableComponent,
        SortableContainer,
        SortableComponent,
        SortableHandleComponent
    ],
    exports: [
        BrowserAnimationsModule,
        CancelButtonComponent,
        FileUploadComponent,
        FileSelectComponent,
        CommonModule,
        TranslateModule,
        ConfigurationModule,
        GridModule,
        DateInputsModule,
        UiModule,
        FormsModule,
        OkButtonComponent,
        SecondaryButtonComponent,
        ReactiveFormsModule,
        RouterModule,
        DraggableComponent,
        DraggableHandleComponent,
        DroppableComponent,
        SortableContainer,
        SortableComponent,
        SortableHandleComponent
    ]
})
export class SharedModule {
}
